/**
 * LOGIN ROUTES
 */
const routes = [
  //LOGIN
  {
    path: '/authenticate',
    name: 'loginViewComponent',
    component: 'Login/loginViewComponent'
  }
];

export default routes;
